import { render, staticRenderFns } from "./DigitalOnBoarding.vue?vue&type=template&id=71ccdbf2&scoped=true&"
import script from "./DigitalOnBoarding.vue?vue&type=script&lang=js&"
export * from "./DigitalOnBoarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ccdbf2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/projects/tus-cc-auth/tus-cc-auth/frontend/tusauth/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn})
